import BaseExpandableCard from 'ui/components/BaseExpandableCard'
import ExpandableCardHeader from 'ui/components/BaseExpandableCard/components/ExpandableCardHeader'
import TaskTypeBadge from 'ui/components/TaskTypeBadge'
import { DetailsContainer } from './styled'

const TemplateCard = ({
  id,
  name,
  taskType,
  expanded,
  onToggle,
  actions,
  children,
  scrollable = false,
  ...cardProps
}) => {
  return (
    <BaseExpandableCard
      id={id}
      expanded={expanded}
      onToggle={onToggle}
      {...cardProps}
      header={
        <ExpandableCardHeader
          badge={<TaskTypeBadge taskType={taskType} variant="template" />}
          title={name}
          right={actions}
        />
      }
    >
      <DetailsContainer $scrollable={scrollable}>{children}</DetailsContainer>
    </BaseExpandableCard>
  )
}

export default TemplateCard
